// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2-pi4","content":"styles_content__1cvA0","selectAll":"styles_selectAll__e6H4f"};